import { render, staticRenderFns } from "./allotListAction.vue?vue&type=template&id=08925551&scoped=true"
import script from "./allotListAction.vue?vue&type=script&lang=js"
export * from "./allotListAction.vue?vue&type=script&lang=js"
import style0 from "./allotListAction.vue?vue&type=style&index=0&id=08925551&prod&scoped=true&lang=css"
import style1 from "./allotListAction.vue?vue&type=style&index=1&id=08925551&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08925551",
  null
  
)

export default component.exports